<template>
  <div class="row mb-3">
    <div class="col-2 labels">
      {{ $t('generic.question', 'Question {no}', { no: number }) }}:
    </div>
    <div class="col-10">
      <div class="answers-card">
        <b-form-group :label="question.question">
          <div
            v-for="item in [1,2,3,4,5]"
            :key="item"
          >
            <div v-if="question['ans' + item]">
              <b-form-radio
                v-model="$v.selectedAnswer.$model"
                :name="'some-radios' + number"
                :value="question['ans' + item].id"
                :disabled="candidateAnswerId != 0 ? true : false"
                :state="$v.selectedAnswer.$dirty ? !$v.selectedAnswer.$error : null"
              >
                {{ question['ans' + item].text }}
              </b-form-radio>
              <div
                v-if="isCandidateApplied"
                class="row"
              >
                <div class="col-9 mt-1">
                  <b-progress
                    :value="question['ans' + item].points < 0 ? 10 : question['ans' + item].points"
                    :max="10"
                    :style="selectedAnswer === question['ans' + item].id ? 'height: 6px' : 'height: 4px'"
                    :variant="progressBarVariant(question['ans' + item].points)"
                    :animated="selectedAnswer === question['ans' + item].id"
                  />
                </div>
                <div
                  class="col-1"
                  style="font-size: 0.9rem;"
                >
                  {{ computePoints(question['ans' + item].points) }}
                </div>
              </div>
            </div>
          </div>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    number: {
      type: Number,
      default: 1
    },
    question: {
      type: Object,
      default: null
    },
    candidateAnswerId: {
      type: Number,
      default: 0
    },
    isCandidateApplied: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedAnswer: null
    }
  },
  validations: {
    selectedAnswer: { required }
  },
  watch: {
    selectedAnswer(val) {
      let data = {
        answerId: val,
        number: this.number
      }
      this.$emit('updateAnswers', data);
    }
  },
  mounted() {
    if(this.candidateAnswerId != 0) {
      this.selectedAnswer = this.candidateAnswerId;
    }
  },
  methods: {
    computePoints(points) {
      switch(points) {
        case -1:
          return this.$t('pages.publish-offer.second-page.killer-questions.accept', 'Accept');
        case 20:
          return this.$t('pages.publish-offer.second-page.killer-questions.discard', 'Discard');
        default:
          return points;
      }
    },
    progressBarVariant(points) {
      switch(points) {
        case -1:
          return "danger";
        case 20:
          return "success";
        default:
          return "secondary";
      }
    },
    validateAnswer() {
      this.$v.$touch()
      return !this.$v.$invalid;
    }
  }
}
</script>

<style lang="scss" scoped>
.answers-card {
  background: rgb(245, 245, 245);
  padding: 0.5rem 1rem;

  .labels {
    font-size: 0.95rem;
  }
}

.smaller-input {
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}
</style>
